import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';



import { AppModule } from './app/app.module';
import * as Sentry from "@sentry/angular";

Sentry.init({
  dsn: "https://6bb6a4666ded104432576cab4eb3ab68@o4507933804331008.ingest.de.sentry.io/4507933946216528",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
